import React from "react";
import EditIcon from "../../../../svg/editIcon";

interface EditIconCellProps {
  value: any;
  handleEditIconClick?: (data: any) => void;
  [key: string]: any;
}

export const EditIconCell: React.FC<EditIconCellProps> = ({
  value,
  handleEditIconClick,
}) => {
  const handleClick = () => {
    if (handleEditIconClick) {
      handleEditIconClick(value);
    } else if (value?.onEdit) {
      value.onEdit();
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <EditIcon width="15" height="15" />
    </div>
  );
};

export default EditIconCell;
